<template >
  <div class="devDialog">
    <el-dialog :title="title" :visible.sync="devDialogVisible" :close-on-click-modal="false">
      <el-form ref="devForm" :model="devForm"  label-width="140px" :rules="rules">
        <div class="dev_form_title"><div>开发者账号</div></div>
        <el-form-item label="开发者手机号码"  class="is-required" prop="mobile" >
          <el-input v-model.trim="devForm.mobile" maxlength="32" placeholder="请输入手机号码..."> </el-input>
        </el-form-item>
        <el-form-item label="密码" class="is-required"  prop="password">
          <el-input v-model.trim="devForm.password" placeholder="请输入密码..."> </el-input>
        </el-form-item>
        <el-form-item label="确认密码" class="is-required"  prop="cfrmpassword">
          <el-input v-model.trim="devForm.cfrmpassword" placeholder="请输入确认密码..."> </el-input>
        </el-form-item>
        <div class="dev_form_title"><div>公司基本信息</div></div>
        <el-form-item label="公司全称" class="is-required"   prop="companyName">
          <el-input v-model.trim="devForm.companyName" maxlength="64" placeholder="请输入公司全称..."></el-input>
        </el-form-item>
        <el-form-item label="联系人" class="is-required"   prop="businessContact">
          <el-input v-model.trim="devForm.businessContact" maxlength="30" placeholder="请输入联系人..."></el-input>
        </el-form-item>
        <el-form-item label="联系电话" class="is-required" prop="contactNumber">
          <el-input v-model.trim="devForm.contactNumber" maxlength="13" placeholder="请输入联系电话..."></el-input>
        </el-form-item>
        <el-form-item label="公司地址" class="is-required" prop="companyAddress">
          <el-input v-model.trim="devForm.companyAddress" maxlength="200" placeholder="请输入公司地址..."></el-input>
        </el-form-item>
        <el-form-item label="公司网址" class="is-required" prop="companyWebsiteAddress">
          <el-input v-model.trim="devForm.companyWebsiteAddress" maxlength="200" placeholder="请输入公司网址..."></el-input>
        </el-form-item>
        <el-form-item label="营业执照号" class="is-required" prop="businessLicenseNumber">
          <el-input v-model.trim="devForm.businessLicenseNumber" maxlength="32" placeholder="请输入营业执照号..."></el-input>
        </el-form-item>
        <el-form-item label="营业执照" class="is-required" prop="businessLicenseUrl">
          <el-input v-model.trim="devForm.businessLicenseUrl" readonly placeholder="请上传正确营业执照照片"></el-input>
          <el-upload
            class="upload-demo"
            :action="COMMON_UPLOAD_API"
            :on-success="handleSuccess"
            :headers="headers"
            :on-remove="handleRemove"
            :file-list="fileList2"
            list-type="picture">
            <el-button size="small" type="primary">上传营业执照</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过10M</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="devDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="save()" v-loading="loading">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/babel">
import devService from '@/service/devService'
import {
  COMMON_UPLOAD_API
} from '@/resource/index'
export default {
  name: 'editDevDialog',
  props: {
    id: {
      type: Number
    },
    value: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.devForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }

    return {
      title: '新增开发者',
      loading: false,
      COMMON_UPLOAD_API: COMMON_UPLOAD_API,
      headers: {
        Authorization: this.$cookie.get('token')
      },
      fileList2: [],
      devForm: {
        mobile: '',
        password: '',
        cfrmpassword: '',
        companyName: '',
        businessContact: '',
        contactNumber: '',
        companyAddress: '',
        companyWebsiteAddress: '',
        businessLicenseNumber: '',
        businessLicenseUrl: ''
      },
      rules: {
        mobile: [
          {
            required: true,
            message: '请输入手机号码',
            trigger: ['blur', 'change']
          },
          {validator: this.$rules.phoneNumber, trigger: 'blur'}
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: ['blur', 'change']
          },
          {
            min: 6,
            max: 18,
            message: '密码长度在 6 到 18 个字符',
            trigger: 'blur'
          }
        ],
        cfrmpassword: [
          {
            required: true,
            message: '请输入公司名称',
            trigger: ['blur', 'change']
          },
          { validator: validatePass2, trigger: 'blur' }
        ],
        companyName: [
          {
            required: true,
            message: '请输入公司名称',
            trigger: ['blur', 'change']
          }
        ],
        businessContact: [
          {
            required: true,
            message: '请输入联系人',
            trigger: ['blur', 'change']
          }
        ],
        contactNumber: [
          {
            required: true,
            message: '请输入联系电话',
            trigger: ['blur', 'change']
          },
          {validator: this.$rules.telephoneNumber, trigger: 'blur'}
        ],
        companyAddress: [
          {
            required: true,
            message: '请输入公司地址',
            trigger: ['blur', 'change']
          }
        ],
        companyWebsiteAddress: [
          {
            required: true,
            message: '请输入公司网址',
            trigger: ['blur', 'change']
          }
        ],
        businessLicenseNumber: [
          {
            required: true,
            message: '请输入营业执照号',
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },
  methods: {
    save () {
      this.loading = true
      this.$refs.devForm.validate(async valid => {
        // 验证通过
        if (valid) {
          // 重置表单
          try {
            if (this.devForm.password !== this.devForm.cfrmpassword) {
              this.$message.error('两次密码不一致')
              this.loading = false
              return false
            }
            await devService.saveDev(this.devForm)
            this.$refs.devForm.resetFields()
            this.$emit('success')
            this.loading = false
            this.devDialogVisible = false
          } catch (e) {
            this.loading = false
            this.$message.error(e && e.msg)
          }
        }
      })
      this.loading = false
    },
    handleRemove (file, fl) {
      this.fileList2 = []
      this.devForm.businessLicenseUrl = ''
    },
    handleSuccess (response, file, fileList2) {
      this.fileList = []
      this.fileList.push(file)
      this.devForm.businessLicenseUrl = response.data
    }
  },
  watch: {
    devDialogVisible (newVal, oldVal) {
      this.title = '新增开发者'
      if (newVal && this.$refs.devForm) {
        this.devForm = {}
        this.fileList2 = []
        this.$refs.devForm.resetFields()
      }
    }
  },
  computed: {
    devDialogVisible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
<style scoped>
.devDialog .dev_form_title{
  font-weight: bold;
  color: #333333;
  font-size: 16px;
  margin-bottom: 50px;
}
</style>
<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/pages/admin/dev-manage/edit-dialog/index.vue